import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { initChalkitTracking, initContactClickTracking } from "./lib/analytics";
import { captureAttribution } from "./lib/attribution";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { ScrollToTop } from "./components/Shared";
import { Toaster } from "./components/ui/toaster";
import ExitIntentPopup from "./components/ExitIntentPopup";
import Home from "./pages/Home";
import About from "./pages/About";
import Coach from "./pages/Coach";
import Classes from "./pages/Classes";
import ClassDetail from "./pages/ClassDetail";
import Hyrox from "./pages/Hyrox";
import PeptidesGlp1 from "./pages/PeptidesGlp1";
import Schedule from "./pages/Schedule";
import Pricing from "./pages/Pricing";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Contact from "./pages/Contact";
import GetStarted from "./pages/GetStarted";
import DropIn from "./pages/DropIn";
import Book from "./pages/Book";
import LiveBig365 from "./pages/LiveBig365";
import GoldStandard from "./pages/GoldStandard";
import WestRoxbury from "./pages/WestRoxbury";
import Admin from "./pages/Admin";
import SetPassword from "./pages/SetPassword";
import Confirm from "./pages/Confirm";
import Unsubscribe from "./pages/Unsubscribe";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfUse from "./pages/TermsOfUse";
import AccessibilityStatement from "./pages/AccessibilityStatement";
import MembershipHold from "./pages/MembershipHold";
import MembershipCancellation from "./pages/MembershipCancellation";
import NotFound from "./pages/NotFound";

function App() {
  useEffect(() => {
    captureAttribution();
    const offChalkit = initChalkitTracking();
    const offContact = initContactClickTracking();
    return () => {
      offChalkit();
      offContact();
    };
  }, []);
  return (
    <div className="App bg-[#0A0A0B] min-h-screen">
      <BrowserRouter>
        <ScrollToTop />
        <ExitIntentPopup />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/coaches/:slug" element={<Coach />} />
            <Route path="/classes" element={<Classes />} />
            <Route path="/classes/:slug" element={<ClassDetail />} />
            <Route path="/hyrox" element={<Hyrox />} />
            <Route path="/peptides-glp1-boston" element={<PeptidesGlp1 />} />
            <Route path="/live-big-365" element={<LiveBig365 />} />
            <Route path="/gold-standard" element={<GoldStandard />} />
            <Route path="/west-roxbury-gym" element={<WestRoxbury />} />
            <Route path="/schedule" element={<Schedule />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/get-started" element={<GetStarted />} />
            <Route path="/drop-in" element={<DropIn />} />
            <Route path="/confirm" element={<Confirm />} />
            <Route path="/unsubscribe" element={<Unsubscribe />} />
            <Route path="/book" element={<Book />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/admin/set-password" element={<SetPassword />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-use" element={<TermsOfUse />} />
            <Route path="/accessibility-statement" element={<AccessibilityStatement />} />
            <Route path="/membership-hold-request" element={<MembershipHold />} />
            <Route path="/membership-cancellation-request" element={<MembershipCancellation />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
